module.exports = __webpack_public_path__ + "img/02-NodeJS.954cd881.png";